import { Navigate, useLocation } from "react-router-dom";
import LoadingIndicator from './LoadingIndicator';
import { TENANT_AUTH } from '../authMode';
import { useAuth } from '../AuthContext';

export default function ProtectedRoute({ children }) {
  return TENANT_AUTH ? <TenantProtected>{children}</TenantProtected> : <LegacyProtected>{children}</LegacyProtected>;
}

function TenantProtected({ children }) {
  const { loading, user, switching } = useAuth();
  const location = useLocation();
  if (switching) return <LoadingIndicator label="Mandant wird gewechselt" sx={{ p: 4 }} />;
  if (loading) return <LoadingIndicator label="Sitzung wird geprüft" sx={{ p: 4 }} />;
  return user ? children : <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
}

function LegacyProtected({ children }) {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
}
